// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ZdLX7","navigationMessage":"Footer_navigationMessage__VIT4S","divider":"Footer_divider__hstCn","actionButtons":"Footer_actionButtons__szId9"};